import { createContext } from 'react';
import { oneOfType, string, node } from 'prop-types';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { jsx, jsxs } from 'react/jsx-runtime';

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var afb = {
  key: 'afb',
  name: 'Active&Fit Brands',
  getDesignTokens: function getDesignTokens(mode) {
    return {
      mode: mode,
      primary: _objectSpread$8({
        main: '#702F8A',
        dark: '#612A80',
        light: '#FFEAFF'
      }, mode === 'dark' && {
        main: '#EFB0FF',
        dark: '#BB5AF2',
        light: '#FFEAFF'
      }),
      secondary: _objectSpread$8({
        main: '#006497',
        dark: '#004B73',
        light: '#E7F2FF'
      }, mode === 'dark' && {
        main: '#CCE5FF',
        dark: '#91CDFF',
        light: '#CCE5FF'
      }),
      tertiary: _objectSpread$8({
        main: '#FDD757',
        dark: '#E8C345',
        light: '#FFF0C3'
      }, mode === 'dark' && {
        main: '#FFF0C3',
        dark: '#E8C345',
        light: '#FDD757'
      })
    };
  }
};

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ashcare = {
  key: 'ashcare',
  name: 'ASHCare',
  getDesignTokens: function getDesignTokens(mode) {
    return {
      mode: mode,
      primary: _objectSpread$7({
        main: '#002D5C',
        light: '#EBF1FF',
        dark: '#001F40'
      }, mode === 'dark' && {
        main: '#42A5F5',
        dark: '#29B6F6',
        light: '#E3F2FD'
      }),
      secondary: _objectSpread$7({
        main: '#0072CE',
        light: '#EBF1FF',
        dark: '#004785'
      }, mode === 'dark' && {
        main: '#009AFA',
        dark: '#1481DA',
        light: '#9EC3FF'
      }),
      tertiary: _objectSpread$7({
        main: '#4F9D1A',
        light: '#EFF8E7',
        dark: '#006700'
      }, mode === 'dark' && {
        main: '#66BB6A',
        dark: '#337500',
        light: '#C2FFC6'
      })
    };
  }
};

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ch = {
  key: 'ch',
  name: 'ChooseHealthy',
  getDesignTokens: function getDesignTokens(mode) {
    return {
      mode: mode,
      primary: _objectSpread$6({
        main: '#0077C8',
        light: '#EAF1FF',
        dark: '#003259'
      }, mode === 'dark' && {
        main: '#0084DB',
        dark: '#488CB7',
        light: '#EAF1FF'
      }),
      secondary: _objectSpread$6({
        main: '#006298',
        light: '#E8F2FF',
        dark: '#003352'
      }, mode === 'dark' && {
        main: '#0084C2',
        dark: '#3C86B4',
        light: '#E8F2FF'
      }),
      tertiary: _objectSpread$6({
        main: '#0093B2',
        light: '#DCF5FF',
        dark: '#003542'
      }, mode === 'dark' && {
        main: '#0093B2',
        dark: '#1788A1',
        light: '#DCF5FF'
      })
    };
  }
};

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var internal = {
  key: 'internal',
  name: 'Internal Apps',
  components: {
    MuiCssBaseline: {
      styleOverrides: function styleOverrides(theme) {
        return {
          body: {
            backgroundColor: theme.palette.background.secondary
          }
        };
      }
    }
  },
  getDesignTokens: function getDesignTokens(mode) {
    return {
      mode: mode,
      primary: _objectSpread$5({
        main: '#2A569D',
        light: '#F6F8FF',
        dark: '#002E6E'
      }, mode === 'dark' && {
        main: '#5993F0',
        dark: '#4C84D0',
        light: '#F6F8FF'
      }),
      secondary: _objectSpread$5({
        main: '#0372D3',
        light: '#BADEFD',
        dark: '#025197'
      }, mode === 'dark' && {
        main: '#0383F2',
        dark: '#187EDC',
        light: '#BADEFD'
      }),
      tertiary: _objectSpread$5({
        main: '#48B5B2',
        light: '#B2DDDF',
        dark: '#008583'
      }, mode === 'dark' && {
        main: '#48B5B2',
        dark: '#009997',
        light: '#B2DDDF'
      })
    };
  }
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var sf = {
  key: 'sf',
  name: 'Silver&Fit',
  getDesignTokens: function getDesignTokens(mode) {
    return {
      mode: mode,
      primary: _objectSpread$4({
        main: '#006580',
        dark: '#003B52',
        light: '#E1F3F8'
      }, mode === 'dark' && {
        main: '#006580',
        dark: '#0085B9',
        light: '#E1F3F8'
      }),
      secondary: _objectSpread$4({
        main: '#00807A',
        dark: '#00543D',
        light: '#B3E2D8'
      }, mode === 'dark' && {
        main: '#008D86',
        dark: '#3F8B74',
        light: '#B3E2D8'
      }),
      tertiary: _objectSpread$4({
        main: '#F26724',
        dark: '#B83600',
        light: '#FF9853'
      }, mode === 'dark' && {
        main: '#F26724',
        dark: '#DA4E14',
        light: '#FF9853'
      })
    };
  }
};

/**
 * Creates shadows for each `elevation` prop on `<Paper/>` components. There are 24 different eleveation levels so each array item correscponds to an elevation
 */
var shadows = ['none', '0px 2px 2px -1px rgba(0, 0, 0, 0.07)', '0px 2px 3px -1px rgba(66, 66, 66, 0.12)', '0px 3px 4px -1px rgba(66, 66, 66, 0.14)', '0px 3px 5px -1px rgba(66, 66, 66, 0.16)', '0px 3px 6px -1px rgba(66, 66, 66, 0.18)', '0px 4px 6px -1px rgba(66, 66, 66, 0.16)', '0px 4px 8px -1px rgba(66, 66, 66, 0.18)', '0px 4px 5px -2px rgba(66, 66, 66, 0.15), 0px 7px 10px 1px rgba(66, 66, 66, 0.07)', '0px 5px 5px -3px rgba(66, 66, 66, 0.15), 0px 8px 10px 1px rgba(66, 66, 66, 0.07)', '0px 5px 6px -3px rgba(66, 66, 66, 0.15), 0px 9px 12px 1px rgba(66, 66, 66, 0.07)', '0px 6px 6px -3px rgba(66, 66, 66, 0.15), 0px 10px 14px 1px rgba(66, 66, 66, 0.08)', '0px 6px 7px -4px rgba(66, 66, 66, 0.15), 0px 11px 15px 1px rgba(66, 66, 66, 0.09)', '0px 7px 8px -4px rgba(66, 66, 66, 0.15), 0px 12px 17px 2px rgba(66, 66, 66, 0.1)', '0px 7px 8px -4px rgba(66, 66, 66, 0.2), 0px 13px 19px 2px rgba(66, 66, 66, 0.14)', '0px 7px 9px -4px rgba(66, 66, 66, 0.2), 0px 14px 21px 2px rgba(66, 66, 66, 0.14)', '0px 8px 9px -5px rgba(66, 66, 66, 0.2), 0px 15px 22px 2px rgba(66, 66, 66, 0.14)', '0px 8px 10px -5px rgba(66, 66, 66, 0.2), 0px 16px 24px 2px rgba(66, 66, 66, 0.14)', '0px 8px 11px -5px rgba(66, 66, 66, 0.2), 0px 17px 26px 2px rgba(66, 66, 66, 0.14)', '0px 9px 11px -5px rgba(66, 66, 66, 0.2), 0px 18px 28px 2px rgba(66, 66, 66, 0.14)', '0px 9px 12px -6px rgba(66, 66, 66, 0.2), 0px 19px 29px 2px rgba(66, 66, 66, 0.14)', '0px 10px 13px -6px rgba(66, 66, 66, 0.2), 0px 20px 31px 3px rgba(66, 66, 66, 0.14)', '0px 10px 13px -6px rgba(66, 66, 66, 0.2), 0px 21px 33px 3px rgba(66, 66, 66, 0.14)', '0px 10px 14px -6px rgba(66, 66, 66, 0.2), 0px 22px 35px 3px rgba(66, 66, 66, 0.14)', '0px 11px 14px -7px rgba(66, 66, 66, 0.2), 0px 23px 36px 3px rgba(66, 66, 66, 0.14)'];

var font = ['Inter', '-apple-system', '"Segoe UI"', '"Helvetica Neue"', 'sans-serif'].join(',');
var typography = {
  fontFamily: font,
  body3: {
    fontSize: '19px',
    letterSpacing: '0.1px',
    lineHeight: 1.2
  },
  button: {
    fontWeight: 700
  },
  h1: {
    fontWeight: 700
  },
  h2: {
    fontWeight: 700
  },
  h3: {
    fontWeight: 600
  },
  h4: {
    fontWeight: 500
  },
  h5: {
    fontWeight: 600
  },
  overline: {
    fontSize: '16px'
  },
  subtitle1: {
    fontWeight: 500
  }
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var palette = {
  getDesignTokens: function getDesignTokens(mode) {
    return {
      mode: mode,
      background: _objectSpread$3({
        secondary: '#FAFAFA'
      }, mode === 'dark' && {
        secondary: '#141414'
      })
    };
  }
};

var Typography = {
  styleOverrides: {
    gutterBottom: function gutterBottom(_ref) {
      var theme = _ref.theme;
      return {
        marginBottom: theme.spacing(2)
      };
    }
  },
  defaultProps: {
    variantMapping: {
      body3: 'p'
    }
  }
};

var Avatar = {
  styleOverrides: {
    root: function root(_ref) {
      var ownerState = _ref.ownerState;
      switch (ownerState.variant) {
        case 'small':
          return {
            width: '32px',
            height: '32px'
          };
        case 'large':
          return {
            width: '56px',
            height: '56px'
          };
        default:
          return {
            width: '40px',
            height: '40px'
          };
      }
    }
  }
};

var DataGrid = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        '.MuiDataGrid-row': {
          '&:hover, &.Mui-hovered': {
            backgroundColor: 'rgba(41, 86, 158, 0.08)'
          },
          '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.grey[200],
            '&:hover, &.Mui-hovered': {
              backgroundColor: 'rgba(41, 86, 158, 0.08)'
            }
          }
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[700],
          color: theme.palette.common.white,
          '.MuiDataGrid-iconSeparator': {
            color: theme.palette.common.white
          },
          // Hide the icon separator that is rendered after the rightmost header cell
          '.MuiDataGrid-columnHeader:last-child .MuiDataGrid-iconSeparator': {
            display: 'none'
          }
        },
        '.MuiDataGrid-menuIconButton': {
          color: theme.palette.common.white
        },
        '.MuiDataGrid-sortIcon': {
          color: theme.palette.common.white
        }
      };
    }
  }
};

var Snackbar = {
  defaultProps: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    }
  }
};

var SnackbarContent = {
  variants: [{
    props: {
      variant: 'info'
    }
  }, {
    props: {
      variant: 'success'
    }
  }, {
    props: {
      variant: 'error'
    }
  }, {
    props: {
      variant: 'warning'
    }
  }],
  styleOverrides: {
    root: function root(_ref) {
      var ownerState = _ref.ownerState,
        theme = _ref.theme;
      var successStyles = {
        background: theme.palette.mode === 'dark' ? '#0C130D' : '#EDF7ED',
        color: theme.palette.mode === 'dark' ? '#CCE8CD' : '#1E4620',
        svg: {
          color: theme.palette.mode === 'dark' ? '#66BB6A' : '#2E7D32'
        }
      };
      switch (ownerState.variant) {
        case 'info':
          return {
            background: theme.palette.mode === 'dark' ? '#071318' : '#E5F6FD',
            color: theme.palette.mode === 'dark' ? '#B8E7FB' : '#014361',
            svg: {
              color: theme.palette.mode === 'dark' ? '#29B6F6' : '#0288D1'
            }
          };
        case 'success':
          return successStyles;
        case 'error':
          return {
            background: theme.palette.mode === 'dark' ? '#160B0B' : '#FDEDED',
            color: theme.palette.mode === 'dark' ? '#F4C7C7' : '#5F2120',
            svg: {
              color: theme.palette.mode === 'dark' ? '#F44336' : '#D32F2F'
            }
          };
        case 'warning':
          return {
            background: theme.palette.mode === 'dark' ? '#191207' : '#FFF4E5',
            color: theme.palette.mode === 'dark' ? '#FFE2B7' : '#663C00',
            svg: {
              color: theme.palette.mode === 'dark' ? '#FFA726' : '#ED6C02'
            }
          };
        default:
          // return success styles by default to mimic what MUI Alert does: https://mui.com/material-ui/api/alert/;
          return successStyles;
      }
    }
  }
};

var Button = {
  defaultProps: {
    disableElevation: true,
    color: 'secondary'
  },
  styleOverrides: {
    root: {
      paddingTop: '8px',
      paddingBottom: '8px'
    }
  }
};

var FloatingActionButton = {
  styleOverrides: {
    root: function root(_ref) {
      var ownerState = _ref.ownerState;
      switch (ownerState.variant) {
        // TODO: would this make more sense as a separate styled component than a variant?
        case 'videoButton':
          return {
            '&.Mui-disabled': {
              backgroundColor: 'rgba(0, 0, 0, 0.42)'
            }
          };
        default:
          return {};
      }
    }
  }
};

var Container = {
  styleOverrides: {
    // `maxWidth` is set to **at most** `1440px`. See changelog ## 1.0.0-alpha.6
    maxWidthXl: function maxWidthXl(_ref) {
      var theme = _ref.theme;
      return _defineProperty({}, theme.breakpoints.up('lg'), {
        maxWidth: '1440px'
      });
    }
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Drawer = {
  styleOverrides: {
    root: function root(_ref) {
      var ownerState = _ref.ownerState,
        theme = _ref.theme;
      return _objectSpread$2({}, ownerState.variant === 'permanent' && {
        '& .MuiDrawer-paper': _defineProperty({
          width: '100%',
          boxSizing: 'border-box',
          borderRight: 0
        }, theme.breakpoints.up('md'), {
          width: 360
        })
      });
    }
  }
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Paper = {
  styleOverrides: {
    root: function root(_ref) {
      var ownerState = _ref.ownerState,
        theme = _ref.theme;
      return _objectSpread$1({}, ownerState.variant === 'wrapper' && {
        padding: theme.spacing(4)
      });
    }
  }
};

var components = {
  MuiTypography: Typography,
  MuiAvatar: Avatar,
  MuiSnackbar: Snackbar,
  MuiSnackbarContent: SnackbarContent,
  MuiButton: Button,
  MuiFab: FloatingActionButton,
  MuiContainer: Container,
  MuiDrawer: Drawer,
  MuiPaper: Paper,
  MuiDataGrid: DataGrid
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Export the list of themes.
 * TODO: This is used in the storybook preview file for this project only, so maybe we move this out to a dev only file
 */
var themeList = [afb, ashcare, ch, internal, sf];

/**
 * This is the meat of the theme. The consuming React project imports this function and calls `getTheme('afd)` or another theme name.
 */
function getTheme(themeKey) {
  var themeMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'light';
  // get the site theme based on what the consuming project asks for
  var siteThemeData = themeList.find(function (theme) {
    return theme.key === themeKey;
  });
  if (!siteThemeData) {
    throw new Error("The requested theme '".concat(themeKey, "' was not found, please check the list of supported site themes."));
  }
  var globalPalette = palette.getDesignTokens(themeMode);
  var sitePalette = siteThemeData.getDesignTokens(themeMode);
  var theme = createTheme({
    palette: _objectSpread(_objectSpread({}, globalPalette), sitePalette || {}),
    /**
     * Font family must be set in the initial theme creation or it will not apply to text within components
     * if we add back a need to access site palette in typography
     * a seperate object for typography will need to be added to the site theme creation below
     */
    typography: typography
  });

  /**
   * if accessing theme.palette, or theme.[any property] in typography, components, etc. it needs the palette (or whatever theme property) defined already
   * if those get redefined at the site level, the new palette don't actually take effect
   * demo: https://codesandbox.io/s/theme-palettes-o3qy0g?file=/demo.js
   * demo with bug: https://codesandbox.io/s/theme-palettes-with-bug-xxoomv?file=/demo.js
   * This is no longer used but can be added back see demo above for how
   */

  var siteComponents = siteThemeData.components;

  /**
   * Mixes in the global theme above with the individual pieces and site palette
   */
  var siteTheme = createTheme(theme, {
    themeKey: themeKey,
    shadows: shadows,
    components: _objectSpread(_objectSpread({}, components), siteComponents || {})
  });
  return responsiveFontSizes(siteTheme);
}

var ColorModeContext = /*#__PURE__*/createContext({
  toggleColorMode: function toggleColorMode() {}
});
var themeKeys = themeList.map(function (t) {
  return t.key;
});
function EveThemeProvider(_ref) {
  var themeKey = _ref.themeKey,
    themeMode = _ref.themeMode,
    children = _ref.children;
  var theme = getTheme(themeKey, themeMode);
  return /*#__PURE__*/jsx(ColorModeContext.Provider, {
    value: themeMode,
    children: /*#__PURE__*/jsxs(ThemeProvider, {
      theme: theme,
      children: [/*#__PURE__*/jsx(CssBaseline, {}), children]
    })
  });
}

/**
 * Storybook's doc-gen does not support dynamic values so themeKey
 * options will be defined as an argType on the story instead
 * See https://github.com/storybookjs/storybook/issues/14092
 */
EveThemeProvider.propTypes = {
  /**
   * Selected Material UI theme to apply to the provided child structure
   */
  themeKey: oneOfType([string]),
  /**
   * Used to nest arbitrary JSX components in EveTheme provider/context
   */
  children: node.isRequired,
  /**
   * Theme mode: either light or dark
   */
  themeMode: oneOfType([string]).isRequired
};
EveThemeProvider.defaultProps = {
  themeKey: 'internal'
};

export { EveThemeProvider as default, themeKeys };
//# sourceMappingURL=index.esm.js.map
